import { render, staticRenderFns } from "./SlideFrame.vue?vue&type=template&id=45d360e6&scoped=true"
import script from "./SlideFrame.vue?vue&type=script&lang=js"
export * from "./SlideFrame.vue?vue&type=script&lang=js"
import style0 from "./SlideFrame.vue?vue&type=style&index=0&id=45d360e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d360e6",
  null
  
)

export default component.exports